import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import './AllRepaymentList.css'

const AllRepaymentListUI = ({ accountList, prepaymentAccountList, totals, totalLoans, totalNonRFLoans, totalRFLoans, checked, onShowDetailsChange, view, onViewChange }) =>
  <div className='su_ac_rp_l'>
    <span className='g_flex_h g_flex_right'>
      <span className='g_muted g_small g_m_right_50'>
        Change columns
      </span>
      <SwitchUI checked={view} onChange={onViewChange} />
      <span className='g_muted g_small g_m_right_50 g_m_left_50'>
        Loan breakup
      </span>
      <SwitchUI checked={checked} onChange={onShowDetailsChange} />
    </span>
    <TableUI accountList={accountList} totals={totals} totalLoans={totalLoans} totalNonRFLoans={totalNonRFLoans} totalRFLoans={totalRFLoans} view={view} checked={checked} />
    <TableUI accountList={prepaymentAccountList} totals={totals} checked={checked} prepayment={true} />
  </div>

const TableUI = ({ accountList, totals, totalLoans, totalNonRFLoans, totalRFLoans, view, checked, prepayment }) =>
  <CardUI className={`${prepayment ? 'g_m_top_100' : 'g_m_top_50'} g_small`} title={prepayment ? 'Prepayments' : 'Monthly Repayments'}>
    {
      prepayment && <a name='prepayment' />
    }
    {
      true &&
      <table><thead className='g_sticky'>
        <tr className='head'>
          <td></td>
          <td className='left'>Account/Loan</td>

          {
            view &&
            <>
              <td>Loan Amount</td>
              <td>Interest Rate</td>
              <td>Tenure in Months</td>
              <td>EMI Interest</td>
              <td>EMI Principal</td>
              <td>Opening Balance</td>
              <td>Closing Balance</td>
              <td>DSRA<br /><span className='g_error'>Current DSRA</span></td>
              <td>Paid from DSRA</td>
              <td>Days Past Due</td>
            </>
          }
          {
            !view &&
            <>
              <td>EMI<br />
                <span className='g_muted'>GST, </span>
                <i className='g_muted'>TDS</i>
              </td>
              <td>DSRA Dip Interest</td>
              <td>Penal Charge</td>
              <td>Total Due</td>
              <td>Total Paid</td>
              <td>EMI Shortfall</td>
              <td>DSRA Dip Interest Shortfall</td>
              <td>Penal Charge Shortfall</td>
              <td>Pending</td>
              {/* <td>Escrow Balance after Payment</td> */}
            </>
          }
        </tr>
      </thead>
        <tbody>
          {
            accountList.map((account, i) =>
              <React.Fragment key={i}>
                <tr className={`acc ${account.balanceStatus === 'insufficient_balance' ? 'g_error' :
                  account.balanceStatus === 'with_dsra_dip' ? 'g_info' :
                    account.balanceStatus === 'sufficient_balance' ? 'g_success' : ''}`}>
                  <td className='left'>{i + 1}</td>
                  <td className1={`left ${account.totalDSRADipInterestF5 !== '0.00' || account.totalDefaultInterestF5 !== '0.00' ? 'g_error' : ''}`}>{account.accountName}</td>
                  {
                    view &&
                    <>
                      <td>{account.totalLoanAmountF5}</td>
                      <td>{account.totalInterestRate}</td>
                      <td>{account.totalTenor}</td>
                      <td>{account.totalInterestF5}</td>
                      <td>{account.totalPrincipalF5}</td>
                      <td>{account.totalOutstandingBalanceF5}</td>
                      <td>{account.totalClosingBalanceF5}</td>
                      <td>{account.totalDSRAAmountF5}<br />
                        {
                          account.totalDSRACurrentF5 !== account.totalDSRAAmountF5 &&
                          <span className='g_error'>{account.totalDSRACurrentF5}</span>
                        }
                      </td>
                      <td className={totals.yearMonth.past && `${account.totalAmountPaidFromDsraF5 !== '0.00' ? 'g_error' : ''}`}>{account.totalAmountPaidFromDsraF5}</td>
                      <td className={`${account.totalDaysPastDue !== '0' ? 'g_error' : ''}`}>{account.totalDaysPastDue}</td>
                    </>
                  }
                  {
                    !view &&
                    <>
                      <td>{account.totalEMIF5}
                        <span className='g_muted'>{account.totalGSTF5 !== '0.00' && <><br />{account.totalGSTF5}</>}</span>
                        <i className='g_muted'>{account.totalTDSF5 !== '0.00' && <><br />{account.totalTDSF5}</>}</i>
                      </td>
                      <td className={`${account.totalDSRADipInterestF5 !== '0.00' ? 'g_info2' : ''}`}>{account.totalDSRADipInterestF5}</td>
                      <td className={`${account.totalDefaultInterestF5 !== '0.00' ? 'g_info2' : ''}`}>{account.totalDefaultInterestF5}</td>
                      <td>{account.totalPayableF5}</td>
                      <td>{account.totalPaidF5}</td>
                      <td className={totals.yearMonth.past && `${account.totalEMIShortfallF5 !== '0.00' ? 'g_error' : ''}`}>{account.totalEMIShortfallF5}</td>
                      <td>{account.totalDSRAShortfallF5}</td>
                      <td>{account.totalDefaultShortfallF5}</td>
                      <td>{account.totalPendingF5}</td>
                      {/* <td>{account.totalBalanceAfterPayment}</td> */}
                    </>
                  }
                </tr>
                {
                  false && account.dsraEventList && account.dsraEventList.length > 0 &&
                  <tr>
                    <td></td>
                    <td colSpan='20' className='g_error g_small'>
                      {
                        account.dsraEventList.map((d, i) =>
                          <span key={i} className='g_flex_v'>
                            DSRA {d.status}: {d.dateF1}, amount: {d.dsraTotalF5} current: {d.dsraCurrentF5}
                          </span>
                        )
                      }
                    </td>
                  </tr>
                }
                {
                  !view && checked && account.totalDSRADipFormula &&
                  <tr>
                    <td></td>
                    <td colSpan='20' className='g_muted g_small'>DSRA Int: {account.totalDSRADipFormula}</td>
                  </tr>
                }
                {
                  checked && account.repaymentList.map((repayment, j) =>
                    <React.Fragment key={j}>
                      <tr className='loan g_muted'>
                        <td className='left'>{i + 1}.{j + 1}</td>
                        <td className='left'>
                          <Link to={`/su/loans/${repayment.loanId}/repayments/v1`}>
                            {repayment.loanName} ({repayment.loanRefNum})
                          </Link>
                        </td>
                        {
                          view &&
                          <>
                            <td>{repayment.loanAmountF5}</td>
                            <td>{repayment.interestRate}</td>
                            <td>{repayment.tenor}</td>
                            <td>{repayment.interestF5}</td>
                            <td>{repayment.principalF5}</td>
                            <td>{repayment.openingBalanceF5}</td>
                            <td>{repayment.closingBalanceF5}</td>
                            <td>{repayment.dsraAmountF5}<br />
                              {
                                repayment.dsraAmountF5 !== repayment.dsraCurrentF5 &&
                                <span className='g_error'>{repayment.dsraCurrentF5}</span>
                              }
                            </td>
                            <td>{repayment.amountPaidFromDsraF5}</td>
                            <td>{repayment.daysPastDue !== 'null' && repayment.daysPastDue}</td>
                          </>
                        }
                        {
                          !view &&
                          <>
                            <td>{repayment.emiF5}
                              <span className='g_muted'>{repayment.gstF5 && repayment.gstF5 !== '0.00' && <><br />{repayment.gstF5}</>}</span>
                              <i className='g_muted'>{repayment.tdsF5 && repayment.tdsF5 !== '0.00' && <><br />{repayment.tdsF5}</>}</i>
                            </td>
                            <td>{repayment.dsraDipInterestF5}</td>
                            <td>{repayment.defaultInterestF5}</td>
                            <td>{repayment.payableF5}</td>
                            <td>{repayment.paidF5}</td>
                            <td>{repayment.emiShortFallF5}</td>
                            <td>{repayment.dsraShortFallF5}</td>
                            <td>{repayment.defaultShortFallF5}</td>
                            <td>{repayment.pendingAmountF5}</td>
                            {/* <td>{repayment.balanceAfterPaymentF5}</td> */}
                          </>
                        }
                      </tr>
                      {
                        repayment.prepaymentAmountF5 &&
                        <tr>
                          <td></td>
                          <td colSpan='20' className='g_info'>Prepaid: {repayment.prepaymentAmountF5}</td>
                        </tr>
                      }
                      {
                        false && repayment.dsraHistoryList && repayment.dsraHistoryList.length > 0 &&
                        <tr>
                          <td></td>
                          <td colSpan='20' className='g_error g_small'>
                            {
                              repayment.dsraHistoryList.map((d, i) =>
                                <span key={i} className='g_flex_v'>
                                  DSRA {d.status}: {d.dateF1}, amount: {d.dsraAmountF5} current: {d.dsraCurrentF5}
                                </span>
                              )
                            }
                          </td>
                        </tr>
                      }
                      {
                        !view && repayment.dsraDipInterestFormula &&
                        <tr>
                          <td></td>
                          <td colSpan='20' className='g_muted g_small limit'>
                            DSRA Int: {repayment.dsraDipInterestFormula.replace('(waived)', '')}
                            {
                              repayment.dsraDipInterestFormula.includes('(waived)') &&
                              <span className='g_info'><b>(waived)</b></span>
                            }
                          </td>
                        </tr>
                      }
                      {
                        !view && repayment.defaultInterestFormula &&
                        <tr>
                          <td></td>
                          <td colSpan='20' className='g_muted g_small'>Default Int: {repayment.defaultInterestFormula}</td>
                        </tr>
                      }
                    </React.Fragment>
                  )
                }
                {
                  !checked && account.repaymentList.map((repayment, j) =>
                    <React.Fragment key={j}>
                      {
                        repayment.prepaymentAmountF5 &&
                        <tr>
                          <td></td>
                          <td colSpan='20' className='g_info'>Prepaid loan {repayment.loanName}, amount: {repayment.prepaymentAmountF5}</td>
                        </tr>
                      }
                      {/*
              repayment.dsraDipInterestFormula &&
              <tr>
                <td></td>
                <td colSpan='20' className='g_muted g_small limit'>DSRA Int: {repayment.dsraDipInterestFormula}</td>
              </tr>
            */}
                      {/*
              repayment.defaultInterestFormula &&
              <tr>
                <td></td>
                <td colSpan='20' className='g_muted g_small'>Default Int: {repayment.defaultInterestFormula}</td>
              </tr>
            */}
                    </React.Fragment>
                  )
                }
                {
                  !view && checked && account.repaymentList.map((repayment, j) =>
                    <React.Fragment key={j}>
                      {
                        repayment.defaultHistoryList && repayment.defaultHistoryList.length > 0 &&
                        <tr>
                          <td></td>
                          <td colSpan='20' className='g_muted g_small'>
                            {
                              repayment.defaultHistoryList.map((d, i) =>
                                <span key={i} className='g_flex_v'>
                                  Default date: {d.defaultDateF1}, cure date: {d.cureDateF1}
                                  {
                                    d.defaultReason &&
                                    <span className='g_muted'>Default reason: {d.defaultReason}</span>
                                  }
                                </span>
                              )
                            }
                          </td>
                        </tr>
                      }
                    </React.Fragment>
                  )
                }
                {
                  checked && account.repaymentList.map((repayment, j) =>
                    <React.Fragment key={j}>
                      {
                        repayment.remarks &&
                        <tr>
                          <td></td>
                          <td colSpan='20' className='g_muted g_small'>Remarks: {repayment.remarks}</td>
                        </tr>
                      }
                    </React.Fragment>
                  )
                }
              </React.Fragment>
            )
          }
          <tr className='foot'>
            <td></td>
            <td className='left'>Total</td>
            {/* <td></td> */}
            {
              view &&
              <>
                <td>{totals.totalLoanAmountF5}</td>
                <td></td>
                <td></td>
                <td>{totals.totalInterestF5}</td>
                <td>{totals.totalPrincipalF5}</td>
                <td>{totals.totalOutstandingBalanceF5}</td>
                <td>{totals.totalClosingBalanceF5}</td>
                <td>{totals.totalDSRAAmountF5}<br /><span className='g_error'>{totals.totalDSRACurrentF5}</span></td>
                <td>{totals.totalAmountPaidFromDsraF5}</td>
                <td></td>
              </>
            }
            {
              !view && !prepayment &&
              <>
                <td>{totals.totalEMIF5}
                  <span className='g_muted'>{totals.totalGSTF5 !== '0.00' && <><br />{totals.totalGSTF5}</>}</span>
                  <i className='g_muted'>{totals.totalTDSF5 !== '0.00' && <><br />{totals.totalTDSF5}</>}</i>
                </td>
                <td>{totals.totalDSRADipInterestF5}</td>
                <td>{totals.totalDefaultInterestF5}</td>
                <td>{totals.totalPayableF5}</td>
                <td>{totals.totalPaidF5}</td>
                <td>{totals.totalEMIShortfallF5}</td>
                <td>{totals.totalDSRAShortfallF5}</td>
                <td>{totals.totalDefaultShortfallF5}</td>
                <td>{totals.totalPendingF5}</td>
                {/* <td>{totals.totalBalanceAfterPayment}</td> */}
              </>
            }
            {
              !view && prepayment &&
              <>
                <td />
                <td />
                <td />
                <td>{totals.totalPrePaidAmountF5}</td>
                <td>{totals.totalPrePaidAmountF5}</td>
                <td />
                <td />
                <td />
                <td />
                {/* <td>{totals.totalBalanceAfterPayment}</td> */}
              </>
            }
          </tr>
        </tbody></table>
    }
    {
      totalLoans &&
      <div className='g_flex_h'>
        <div className='text-bold'>
          <p>Total number of loans: {totalLoans}</p>
          <p>Total Non-RF loans: {totalNonRFLoans}</p>
          <p>Total RF loans: {totalRFLoans}</p>
        </div>

        <div className='g_m_left_100'>
          <p className='g_error'>Red: Insufficient balance</p>
          <p className='g_info'>Blue: Dsra dip</p>
          <p className='g_success'>Green: Sufficient balance</p>
        </div>
      </div>
    }
  </CardUI >

export default AllRepaymentListUI
